import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-blank-email',
  templateUrl: './blank-email.component.html',
  styleUrls: ['./blank-email.component.css'],
})
export class BlankEmailComponent implements OnInit {
  constructor(private dialog: MatDialog) {
    //modal for blank email
  }

  ngOnInit(): void {
    //
  }

  closeDialog() {
    this.dialog.closeAll();
  }
}
